export const ASIDE_WIDTH = 300;
export const ASIDE_COLLAPSED_WIDTH = 70;
